exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form__row--header{position:relative}.form__row--header:before{content:\"\";display:block;position:absolute;top:50%;left:0;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:calc(100% - 30px);height:1px;background-color:#ced4da}.form__row--header p{background-color:#f5f5f5;padding-right:20px;position:relative;z-index:1}.remove-btn{width:15px;height:15px;position:relative;right:0;top:0}.remove-btn span:after,.remove-btn span:before{width:3px;border-radius:3px;background-color:#fd77a4}", ""]);

// exports
